import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Feed from '../views/Feed.vue'
import Profile from '../views/Profile.vue'
import Contact from '../views/Contact.vue'
import Admin from '../views/Admin.vue'
import Create from '../views/CreateUser.vue'
import CreatePlayer from '../views/CreatePlayer.vue'
import CreatePlayerEdit from '../views/CreatePlayerEdit.vue'
import CreateSlide from '../views/CreateSlide.vue'
import Players from '../views/FeedPlayers.vue'
import Buzon from '../views/Buzon.vue'


Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/feed',
    name: 'Feed',
    component: Feed
    
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  },
  {
    path: '/players',
    name: 'Players',
    component: Players
  },
  {
    path: '/create-player',
    name: 'CreatePlayer',
    component: CreatePlayer
  },
  {
    path: '/edit-player',
    name: 'CreatePlayerEdit',
    component: CreatePlayerEdit
  },
  {
    path: '/buzon',
    name: 'Buzon',
    component: Buzon
  },
  {
    path: '/slideshow',
    name: 'CreateSlide',
    component: CreateSlide
  },

  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
